import React, { ReactNode } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCheckCircle,
  faCircleExclamation,
  faCircleInfo,
  faTriangleExclamation,
} from '@fortawesome/pro-light-svg-icons'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export const TOASTS = {
  success: 'success',
  failure: 'failure',
  info: 'info',
  warning: 'warning',
} as const

type ToasterType = (typeof TOASTS)[keyof typeof TOASTS]

export const TOAST_ICONS: Record<ToasterType, ReactNode> = {
  success: <FontAwesomeIcon icon={faCheckCircle as IconProp} />,
  failure: <FontAwesomeIcon icon={faCircleExclamation as IconProp} />,
  info: <FontAwesomeIcon icon={faCircleInfo as IconProp} />,
  warning: <FontAwesomeIcon icon={faTriangleExclamation as IconProp} />,
}
